import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
const customStyle = {
    verticalAlign: '-0.2em',
    fontSize: 'inherit',
};
export default function TextSupWeb({ verticalAlign, children }) {
    // Note: Inherits text color & weight from _text_ parent
    return (_jsx("sup", { style: StyleSheet.flatten([
            customStyle,
            !!verticalAlign && { verticalAlign },
        ]), children: children }));
}
